/// <amd-module name="Analytics/Shared/TrendChart/Common/Types" />
import { ITrendReportConfiguration } from "Analytics/Shared/Common/Types";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { IEventHandler } from "VSS/Reflux/Store";

export interface IFilterItem {
    id: number;
    name: string;
}

export interface ITrendChartReportConfiguration extends ITrendReportConfiguration{
    branchItems?: IFilterItem[];
}

export interface ITrendChartReportData {
    confValues?: ITrendChartReportConfiguration;
    isCachedData?: boolean;
}

export interface ITrendChartCustomData {
    label: string;

    // The type can be extended based on requirement
    value: number;
}

export interface ITrendChartAggregateData {
    date: string;
    aggrValue: number;
    customData?: ITrendChartCustomData;
}

export interface ITrendChartData extends ITrendChartReportData {
    primaryChartData: { [key: string]: ITrendChartAggregateData[] };
    secondaryChartData?: ITrendChartAggregateData[];
}

export interface ITrendChartState {
    metricsOptions?: { [key: number]: string };
    metricSelected?: number;
    chartOptions?: ChartProps;
    errorText?: string;
}

export interface ITrendChartStore {
    getState(): ITrendChartState;
    addChangedListener(handler: IEventHandler): void;
    removeChangedListener(handler: IEventHandler): void;
}

export interface INormalizedDuration {
    durationUnitString: string;
    durationValues: number[][];
}
